import ticker from '@/lib/ticker'
import videoAnalyzer from './videoAnalyzer'

interface IOptions {
  fps?: number
  width?: number
  onProcess?: (process: string) => void
}
interface ICommonConvertor {
  debug: boolean
  isCompatible: boolean
  start: (options: IOptions) => Promise<Blob>
}
const imageListConvertor: ICommonConvertor = {
  debug: true,
  isCompatible: false,
  start: (
    { fps = 12, width = 100, onProcess = (process: string) => process } = {
      fps: 12,
      width: 100,
      onProcess: (process: string) => process,
    },
  ) => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
    const video = videoAnalyzer.video as HTMLVideoElement

    const resultWidth = Math.min(width, video.videoWidth)
    const resultWidthRatio = resultWidth / video.videoWidth
    const resultHeight = resultWidthRatio * video.videoHeight

    canvas.width = resultWidth
    canvas.height = resultHeight
    canvas.style.display = 'none'
    document.body.appendChild(canvas)

    return new Promise((resolve, reject) => {
      const canvasImages: string[] = []
      const computeFrame = () => {
        onProcess(`${((video.currentTime / video.duration) * 100).toFixed(2)}%`)
        ctx.drawImage(video, 0, 0, resultWidth, resultHeight)
        const dataUrl = canvas.toDataURL()
        canvasImages.push(dataUrl)
      }

      video.addEventListener('play', () => {
        ticker.start(
          () => {
            if (video.paused || video.ended) {
              ticker.pause()
            }
            computeFrame()
          },
          { fps },
        )
      })

      video.addEventListener('ended', () => {
        // base64 to blob object
        const imageList = JSON.stringify(canvasImages).split(',')
        let imgtype = ''
        if (imageList.length > 1) {
          imgtype = imageList[0].substring(imageList[0].indexOf(':') + 1, imageList[0].indexOf(';'))

        }
        const blob = new Blob(canvasImages, { type: imgtype })

        document.body.removeChild(canvas)
        resolve(blob)
      })

      video.play()
    })
  },
}

const detect = () => {
  const imgType = 'image/png'
  if (['image/png', 'image/jpg', 'image/jpeg', 'image/bmp', 'image/svg', 'image/webp'].includes(imgType)) {
    imageListConvertor.isCompatible = true
  } else {
    imageListConvertor.isCompatible = false
  }
}
detect()

export default imageListConvertor
